import gql from 'graphql-tag';
import { apollo } from 'src/features';
import { parseConfig } from 'api/getChannels';

const query = gql`
query Activity($id: ID!) {
  activity(id: $id) {
    state
    channelType
    channelName
    avatarUrl
    customer {
      id
      firstName
      lastName
      identified
    }
    operator {
      id
      name
      firstName
      lastName
      displayName
      avatarUrl
    }
    requestType {
      name
    }
    caseMessages{
      ...msg
    }
    virtualOperator
    channel {
      id
      config
    }
  }
}

fragment msg on Message {
    id
    sender
    insertedAt
    body
    isRead
    customerId
    operatorId
    activityId
    receiver
    to
    from
    copies
    auto
    attachments {
      title
      type
      size
      original
      preview
      ext
    }
}`;

function parse(item) {
  return {
    state: item.state,
    channelType: item.channelType,
    channelName: item.channelName,
    customer: item.customer,
    operator: item.operator,
    messages: item.caseMessages,
    case: item.case,
    requestType: item.requestType,
    virtualOperator: item.virtualOperator,
    config: parseConfig(item.channel.config),
    avatarUrl: item.avatarUrl,
    channel: item.channel,
  };
}

function getActivityAndCaseMessages(id) {
  return apollo.client.query({
    variables: { id },
    query,
    fetchPolicy: 'network-only',
  }).then((res) => parse(res.data.activity));
}

export default getActivityAndCaseMessages;
